<template>
  <div id="myCustomer-tree-grid" class="grid-view">
    <div style="display:flex;flex-direction: row; flex: 1;">
      <ul class="custom-category-list section">
        <li :class="[customerStatusCode===-1?'active':'']" no="1" @click="categoryClick(-1)">{{ $t('CargoMsg.Cargo_All') }}({{ allCustomerCount }})</li>
        <li class="potential" :class="[customerStatusCode===0?'active':'']" no="2" @click="categoryClick(0)">{{ $t('CargoMsg.Cargo_PotentialStage') }}({{ potentialCount }})</li>
        <li class="contemplation" :class="[customerStatusCode===1?'active':'']" no="3" @click="categoryClick(1)">{{ $t('CargoMsg.Cargo_IntentionStage') }}({{ contemplationCount }})</li>
        <li class="business" :class="[customerStatusCode===2?'active':'']" no="4" @click="categoryClick(2)">{{ $t('CargoMsg.Cargo_NegotiationStage') }}({{ businessCount }})</li>
        <li class="cooperation" :class="[customerStatusCode===3?'active':'']" no="5" @click="categoryClick(3)">{{ $t('CargoMsg.Cargo_CooperationStage') }}({{ cooperationCount }})</li>
      </ul>
      <div class="main-content">
        <!-- 231502: 我的客户 231505: 本组客户-->
        <search-item
          :config-module="modelType===0?'231502':'231505'"
          :reset="true"
          :custom-sim-query-placeholder="$t('CargoMsg.Cargo_CustomerQuickSearch')"
          :custom-search-items="customSearchItems"
          no="6"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <template slot="operations">
            <!--各模块公共使用=================================================-->
            <!--录入-->
            <el-button :disabled="parseInt(customerStatusCode) === parseInt(CrmCustomerConstants.STAGE_COOPERATION.code)" type="primary" no="7" @click="createHandler()">{{ $t('CargoMsg.Cargo_Enter') }}</el-button>
            <!--查看-->
            <el-button :disabled="!selectedJob || total <= 0" type="success" no="8" @click="toLook()">{{ $t('common.btn.look') }}</el-button>

            <!--我的客户模块使用=================================================-->
            <!--签单-->
            <el-button v-show="modelType === 0 && $checkPermission(['role_CRMMyCustomerManager_sign'])" :disabled="!selectedJob" type="primary" no="9" @click="signHandler(modelType)">{{ $t('CargoMsg.Cargo_SignContract') }}</el-button>
            <!--释放-->
            <el-button v-show="modelType === 0 && $checkPermission(['button_CRMMyCustomerManager_release'])" :disabled="!selectedJob" type="primary" no="10" @click="releaseHandler()">{{ $t('CargoMsg.Cargo_Release') }}</el-button>
            <!--导入模板下载-->
            <el-button v-show="modelType === 0" type="primary" no="11" @click="btnInitTemplateClickHandler()">{{ $t('Partners.downloadImportTemplate') }}</el-button>
            <!--批量导入-->
            <el-upload
              v-show="modelType === 0"
              :action="actionUrl"
              :headers="{sessionId:$store.getters.token}"
              :show-file-list="false"
              accept=".xls, .xlsx"
              no="12"
              :before-upload="beforeUpload"
              :on-success="uploadSuccess"
              style="display: inline-block;padding-left: 5px;"
            >
              <el-button type="primary">{{ $t('SeaExport.batchImport') }}</el-button>
            </el-upload>
            <!--新增事件记录-->
            <el-button v-show="modelType === 0" :disabled="!(selectedJobs && selectedJobs.length === 1)" style="margin-left: 5px;" type="primary" no="newEventRecord" @click="newEventRecordHandler()">{{ $t('CargoMsg.Cargo_newEventRecord') }}</el-button>

            <!--本组客户模块使用=================================================-->
            <!--释放 !(selectedJob && (!selectedJob.ownerId || parseInt(selectedJob.ownerId) === 0))-->
            <el-button v-show="modelType === 1" style="margin-left: 5px;" type="primary" no="13" @click="releaseHandler()">{{ $t('CargoMsg.Cargo_Release') }}</el-button>
            <!--分配 !(selectedJob && (!selectedJob.ownerId || parseInt(selectedJob.ownerId) === 0))-->
            <el-button v-show="modelType === 1" type="primary" no="14" @click="assignHandler()">{{ $t('CargoMsg.Cargo_Distribution') }}</el-button>
            <!--签单-->
            <el-button v-show="modelType === 1 && $checkPermission(['role_CRMMyGroupCustomerManager_sign'])" :disabled="!selectedJob" type="primary" no="15" @click="signHandler(modelType)">{{ $t('CargoMsg.Cargo_SignContract') }}</el-button>
            <!--延长期限 !(selectedJob && (!selectedJob.ownerId || parseInt(selectedJob.ownerId) === 0))-->
            <el-button v-show="modelType === 1" type="primary" no="16" @click="additionalHandler()">{{ $t('CargoMsg.Cargo_ExtendPeriod') }}</el-button>
            <!--导出Excel-->
            <el-button v-show="modelType === 1 && !($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)" type="primary" no="17" @click="exportExcelEvent()">{{ $t('CargoMsg.Cargo_ExcelExport') }}</el-button>
            <!--删除-->
            <el-button v-show="modelType === 1" type="primary" no="18" @click="deleteHandler()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </template>
        </search-item>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            :config-module="modelType===0?'23150200':'23150500'"
            :grid-options="gridOptions"
            :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="gridParams"
            :check-main-record="false"
            :deselect-main-record="false"
            style="width: 100%;"
            no="19"
            @gridReady="onGridReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            :config-module="modelType===0?'23150201':'23150501'"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            no="20"
            @pagination="toQuery()"
          />
        </div>
      </div>
    </div>
    <!-- 签单弹框-->
    <sign-match-title-window
      v-if="signMatchTitleWindow.visible"
      :visible.sync="signMatchTitleWindow.visible"
      :enabled-no-join="true"
      :client="selectedJob || {}"
      no="21"
      @signSuccessCallBack="signSuccessCallBackHandler"
    />

    <!-- 分配 -->
    <el-dialog
      v-if="customerAssignWindow.visible"
      v-el-drag-dialog
      :visible.sync="customerAssignWindow.visible"
      :title="$t('CargoMsg.Cargo_Distribution')"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('Payment.sales')">
          <cargo-user-select
            :method-params="{category:'role',shape:'sales'}"
            :default-value="customerAssignWindow.sales||''"
            style="width: 230px;"
            no="22"
            @change="p=>{customerAssignWindow.sales=p.value||0}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="23" @click="enterAssignHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="24" @click="customerAssignWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 延长期限 -->
    <el-dialog
      v-if="customerAdditionalWindow.visible"
      v-el-drag-dialog
      :visible.sync="customerAdditionalWindow.visible"
      :title="$t('CargoMsg.Cargo_ExtendPeriod')"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="customerAdditionalWindow.isPartner?$t('CargoMsg.Cargo_DaysOfSleep'):$t('CargoMsg.Cargo_DaysFromContractSigned')" style="padding-left: 40px;">
          <el-input-number v-model="customerAdditionalWindow.days" :min="1" :max="2147483647" :precision="0" controls-position="right" no="25" />
          <span style="padding-left: 10px;">{{ $t('Partners.day') }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="26" @click="enterAdditionalHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="27" @click="customerAdditionalWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog
      v-if="eventRecordDialog.visible"
      id="eventRecordDialog"
      v-el-drag-dialog
      :visible.sync="eventRecordDialog.visible"
      :title="$t('CargoMsg.Cargo_EventRecord')"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      no="100"
    >
      <div class="app-main-inner-row">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_theme')" required>
            <el-select
              v-model="eventRecordDialog.form.titleName"
              style="width: 100%"
              :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
              size="mini"
              no="101"
            >
              <el-option
                v-for="(item,index) in CrmCustomerConstants.CUSTOMER_EVENT_SUBJECTS"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaskTime')">
            <el-date-picker
              v-model="eventRecordDialog.form.taskTime"
              style="width: 100%"
              type="datetime"
              :clearable="false"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd HH:mm"
              :disabled="!(eventRecordDialog.isEditTime)"
              :editable="false"
              no="102"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Recorder')">
            <el-input v-model="eventRecordDialog.form.recorderName" :disabled="true" style="width: 100%" no="8" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_RecordTime')">
            <el-date-picker
              v-model="eventRecordDialog.form.recordTime"
              type="datetime"
              style="width: 100%"
              format="yyyy-MM-dd HH:mm"
              :disabled="true"
              no="103"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EventStatus')" required>
            <el-select
              v-model="eventRecordDialog.form.status"
              style="width: 100%"
              :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
              size="mini"
              no="104"
            >
              <el-option
                v-for="(item,index) in CrmCustomerConstants.CUSTOMER_EVENT_STATUSS"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Location')">
            <el-input v-model="eventRecordDialog.form.address" no="105" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Participant')">
            <el-input v-model="eventRecordDialog.form.participants" type="textarea" :rows="3" no="106" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ContentDescription')">
            <el-input v-model="eventRecordDialog.form.content" type="textarea" :rows="9" no="107" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Outcomes')">
            <el-input v-model="eventRecordDialog.form.achievement" type="textarea" :rows="3" no="108" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NextStep')">
            <el-input v-model="eventRecordDialog.form.nextTask" type="textarea" :rows="3" no="109" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ReportTo')">
            <el-input v-model="eventRecordDialog.form.reportTarget" type="textarea" :rows="2" no="110" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input v-model="eventRecordDialog.form.remarks" type="textarea" :rows="3" no="111" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SupervisorComments')">
            <el-input v-model="eventRecordDialog.form.supervisorComments" type="textarea" :rows="3" :disabled="!eventRecordDialog.editSupervisorComments" no="112" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" no="113" @click="recordDialogSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="114" @click="recordDialogClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import {
  queryQuotationClientPageable,
  updateCountData,
  releaseQuotationClients,
  assignQuotationClients,
  updateQuotationClientField,
  saveQuotationClientEvent
} from '@/api/sales/quotationClient'
import {
  getMyCustomerSelectType
} from '@/api/basicData/customerRating'
import { checkDeleteCustomer, deleteCustomer } from '@/api/company'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnTagRenderer from '@/components/Cargo/Common/ColumnTagRenderer'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import signMatchTitleWindow from '@/views/cargo/v0/Sales/components/crm/signMatchTitleWindow'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import moment from 'moment'
import { cache } from '@/utils/cacheManager'
import { getUserInfo } from '@/utils/auth'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getObjectByCache, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { OPERATOR_IN } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { basicCacheKeys } from '@/utils/cacheConfig'
import lodash from 'lodash'
import $store from '@/store'

export default {
  name: 'MyCustomerTreeGrid',
  components: {
    cargoUserSelect,
    signMatchTitleWindow,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem
  },
  props: {
    modelType: { type: Number, required: true, default: 1 }, // 模块类型 0.我的客户  1.本组客户  2.客户公海  3.客户回收站
    showSourceType: { type: Boolean, required: false, default: true } // 是否显示客户来源
  },
  data() {
    return {
      ColumnUtils,
      CrmCustomerConstants,
      selectTypeNames: TYPE_NAMES,
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      isAdvancedQuery: false, // 是否为高级查询
      total: 0,
      selectedJob: null,
      gridParams: {},
      gridOptions: {
        frameworkComponents: {
          ColumnTagRenderer
        },
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedJobs = event.api.getSelectedRows()
          this.onGridRowSelected(event)
        },
        getRowStyle: (params) => {
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
        },
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: event => { this.toLook(event.data) }
      },
      columnDefs: [ // 显示列
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ClientNo'),
          field: 'clientId',
          colId: 'clientId',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'name',
          colId: 'name',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          colId: 'englishName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BranchCompany'),
          field: 'branchId',
          colId: 'branchId',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ScaleOfCompanyEmployees'),
          field: 'companySize',
          colId: 'companySize',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RegisteredCapitalIn10Thousand'),
          field: 'registeredCapital',
          colId: 'registeredCapital',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreatedDate'),
          field: 'dateCreated',
          colId: 'dateCreated',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AssessedClientLevel'),
          field: 'customerLevelCode',
          colId: 'customerLevelCode',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            if (!params.value) params.value = '0'
            const code = this.customerSelectTypes.customerLevelCode.find(item => parseInt(item.code) === parseInt(params.value))
            return !code ? '' : $store.getters.language === 'zh' ? code.chineseName : code.englishName
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DifficultyIndex'),
          field: 'overcomeLevelCode',
          colId: 'overcomeLevelCode',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            if (!params.value) params.value = '0'
            const code = this.customerSelectTypes.overcomeLevelCode.find(item => parseInt(item.code) === parseInt(params.value))
            return !code ? '' : $store.getters.language === 'zh' ? code.chineseName : code.englishName
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerContactChannel'),
          field: 'customerContactChannel',
          colId: 'customerContactChannel',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.customerContactChannelLabelFun(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ClientStatus'),
          field: 'customerStatusCode',
          colId: 'customerStatusCode',
          cellRendererSelector: (params) => {
            const render = {
              component: 'ColumnTagRenderer'
            }
            const { customerStatusCode } = params.data
            render.params = {
              color: this.tagColor[customerStatusCode],
              value: ColumnUtils.customerStatusCodeToColumnLabelFun(customerStatusCode)
            }
            return render
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerType'),
          field: 'companyTypeCode',
          colId: 'companyTypeCode',
          cellRenderer: (params) => {
            return ColumnUtils.companyTypeCodeToColumnLabelFun(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SourceOfClient'),
          field: 'sourceType',
          colId: 'sourceType',
          hide: !this.showSourceType,
          cellRenderer: (params) => {
            return ColumnUtils.sourceTypeCodeToColumnLabelFun(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_FirstContactDate'),
          field: 'firstMeetDate',
          colId: 'firstMeetDate',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Competitor'),
          field: 'competitorCompany',
          colId: 'competitorCompany',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Sales'),
          field: 'ownerId',
          colId: 'ownerId',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_30DaysShpt'),
          field: 'freightVolume30',
          colId: 'freightVolume30',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_60DaysShpt'),
          field: 'freightVolume60',
          colId: 'freightVolume60',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_90DaysShpt'),
          field: 'freightVolume90',
          colId: 'freightVolume90',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Over90DaysShpt'),
          field: 'freightVolumeGt90',
          colId: 'freightVolumeGt90',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_DaysNotFollowedUp'),
          field: 'unAskDays',
          colId: 'unAskDays',
          hide: true,
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return ColumnUtils.formatUnAskDays(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreferredShippingRoute'),
          field: 'airlineCode',
          colId: 'airlineCode',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.likeAirlineCode(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreferredPort'),
          field: 'seaPortCode',
          colId: 'seaPortCode',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.likeSeaPortCode(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreferredAirport'),
          field: 'airPortCode',
          colId: 'airPortCode',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.likeAirPortCode(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Country'),
          field: 'country',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, this.isZh ? 'chineseName' : 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abbreviation'),
          field: 'shortName',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContactName'),
          colId: 'contactName',
          field: 'contactName',
          width: 150,
          hide: this.modelType !== 0
        }, {
          headerName: this.$t('CargoMsg.Cargo_Tel'),
          colId: 'contactPhone',
          field: 'contactPhone',
          width: 150,
          hide: this.modelType !== 0
        }, {
          headerName: this.$t('Message.CellPhoneNumber2'),
          colId: 'contactCellphone',
          field: 'contactCellphone',
          width: 150,
          hide: this.modelType !== 0
        }, {
          headerName: this.$t('CargoMsg.CargoMsg_QQ'),
          colId: 'contactQqAccout',
          field: 'contactQqAccout',
          width: 150,
          hide: this.modelType !== 0
        }, {
          headerName: this.$t('CargoMsg.Cargo_Wechat'),
          colId: 'contactWechatAccout',
          field: 'contactWechatAccout',
          width: 150,
          hide: this.modelType !== 0
        }, {
          headerName: this.$t('CargoMsg.Cargo_email'),
          colId: 'contactEmail',
          field: 'contactEmail',
          width: 150,
          hide: this.modelType !== 0
        }
      ],
      rowData: [],
      gridApi: null,
      conditions: [],
      customerStatusCode: -1,
      potentialCount: 0,
      contemplationCount: 0,
      businessCount: 0,
      cooperationCount: 0,
      allCustomerCount: 0,
      tagColor: {
        0: '#8DCE64', // 潜在阶段
        1: '#00A795', // 意向阶段
        2: '#00A6F4', // 商务阶段
        3: '#5469BA' // 合作阶段
      },
      signMatchTitleWindow: { // 签单
        visible: false
      },
      customerAssignWindow: { // 分配
        visible: false,
        sales: '',
        selectedItems: []
      },
      customerAdditionalWindow: { // 延长期限
        visible: false,
        isPartner: false,
        client: null,
        days: 0,
        selectedItems: []
      },
      viewAllCustomer: false, // 销售查看所有的客户权限
      eventRecordDialog: {
        isEditTime: false, // 是否可以编辑时间
        isEdit: false, // 是否编辑状态
        visible: false,
        editSupervisorComments: false, // 是否可以编辑主管评论
        form: {},
        initialForm: {
          uuid: '',
          taskTime: '',
          recorderId: 0,
          recorderName: '',
          address: '',
          participants: '',
          titleName: '',
          status: '',
          content: '',
          recordTime: '',
          remarks: '',
          supervisorComments: '',
          quotationClientUuid: ''
        }
      },
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      selectedJobs: [],
      customerSelectTypes: {
        customerLevelCode: [],
        overcomeLevelCode: [],
        loaded: false
      }
    }
  },
  computed: {
    actionUrl() { // 客户批量导入地址
      return URL.crm.saveExcelFile + '?sessionId=' + this.$store.getters.token + '&currentBranchId=' + this.$store.getters.currentOfficeId + '&fileName=ImportQuotationClientResult.xls&folderName=sales'
    },
    customSearchItems() { // 自定义高级查询项
      return this.getCustomSearchItems()
    },
    paginationConfigModule() { // 自定义高级查询项
      return this.modelType === 0 ? '23150201' : '23150501'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  created() {
    this.conditions = []
    if (this.paginationConfigModule) {
      const currentUserInfo = getUserInfo()
      const cachePageSize = JSON.parse(localStorage.getItem(`local_pagination_page_size_cache_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.paginationConfigModule}`))
      if (cachePageSize) this.filter.pageSize = cachePageSize
    }
    this.viewAllCustomer = this.$checkPermission(['role_CRMMyGroupCustomerManager_viewAllCustomer'])
    this.toQuery()
  },
  methods: {
    async loadCustomerSelectTypes() {
      if (this.customerSelectTypes.loaded) return

      try {
        const res = await getMyCustomerSelectType()
        if (res.code === '0') {
          this.customerSelectTypes.customerLevelCode = res.data.customerLevelList || []
          this.customerSelectTypes.overcomeLevelCode = res.data.difficultyList || []
          this.customerSelectTypes.loaded = true
        }
      } catch (error) {
        console.error('获取客户选择类型失败:', error)
      }
    },
    // 组装查询条件
    getCustomSearchItems() {
      const defaultSearchFields = []
      // 客户来源
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'quotationClient.SOURCE_TYPE'
      searchField.itemLabel = 'CargoMsg.Cargo_SourceOfClient'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = 'CrmCustomerConstants.SOURCE_TYPE'
      searchField.dataCacheKey = 'local_cache_CrmCustomerConstants$SOURCE_TYPE'
      searchField.lock = false
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      // 客户类型 CARGO-25396 客户类型、客户接触渠道改为基础数据维护
      let crmCustomerTypeList = CrmCustomerConstants.CUSTOMER_TYPE
      crmCustomerTypeList = crmCustomerTypeList.concat(getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CrmCustomerType))
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'quotationClient.COMPANY_TYPE_CODE'
      searchField.itemLabel = 'CargoMsg.Cargo_CustomerType'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = crmCustomerTypeList
      defaultSearchFields.push(searchField.formatObj2Json())

      // 销售[本组模块使用]
      if (this.modelType === 1) {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'user'
        searchField.subType = {
          category: 'role',
          shape: 'sales',
          officeId: null
        }
        searchField.multiple = 0
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_USER'
        searchField.itemName = 'quotationClient.OWNER_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_Sales'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.dataCacheKey = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      // 即将到期天数
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.subType = 'bigdecimalForPositive'
      searchField.precision = '0'
      searchField.fieldType = 'FIELD_NUMBER'
      searchField.itemName = 'quotationClient.DUE_TIME'
      searchField.itemLabel = 'CargoMsg.Cargo_DaysToContractExpiry'
      searchField.itemValue = undefined
      searchField.defaultSelected = this.modelType === 0 ? 1 : 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = undefined
      defaultSearchFields.push(searchField.formatObj2Json())

      // 未跟进天数
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.subType = 'bigdecimalForPositive'
      searchField.precision = '0'
      searchField.fieldType = 'FIELD_NUMBER'
      searchField.itemName = 'quotationClient.UN_ASK_DAYS'
      searchField.itemLabel = 'CargoMsg.Cargo_DaysNotFollowedUp'
      searchField.itemValue = undefined
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = undefined
      defaultSearchFields.push(searchField.formatObj2Json())

      // 所属城市
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'countryAreaCascader'
      searchField.itemCondition = [OPERATOR_IN]
      searchField.defaultConditionVal = OPERATOR_IN.code
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'quotationClient.PROVINCE'
      searchField.itemLabel = 'CargoMsg.Cargo_City'
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      // CARGO-45606 CRM模块中，增加合作伙伴简称字段
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'quotationClient.SHORT_NAME'
      searchField.itemLabel = 'CargoMsg.Cargo_Abbreviation'
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      if (this.modelType === 0 || this.modelType === 1 || this.modelType === 2) {
        // 获取客户评定等级，及攻克难度指数数据
        this.loadCustomerSelectTypes()
        console.log('this.customerSelectTypes', JSON.stringify(this.customerSelectTypes))
        // 客户评定等级
        const customerLevelCode = this.customerSelectTypes.customerLevelCode
        // 攻克难度指数
        const overcomeLevelCode = this.customerSelectTypes.overcomeLevelCode
        if (customerLevelCode && customerLevelCode.length > 0) {
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.UPDATE_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
          searchField.itemName = 'quotationClient.CUSTOMER_LEVEL_CODE'
          searchField.itemLabel = 'CargoMsg.Cargo_AssessedClientLevel'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = customerLevelCode
          defaultSearchFields.push(searchField.formatObj2Json())
        }

        if (overcomeLevelCode && overcomeLevelCode.length > 0) {
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.UPDATE_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
          searchField.itemName = 'quotationClient.OVERCOME_LEVEL_CODE'
          searchField.itemLabel = 'CargoMsg.Cargo_DifficultyIndex'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = overcomeLevelCode
          defaultSearchFields.push(searchField.formatObj2Json())
        }

        let customerContactChannelList = CrmCustomerConstants.CUSTOMER_CONTACT_CHANNEL_GRID
        customerContactChannelList = customerContactChannelList.concat(getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CustomerContactChannel))
        if (customerContactChannelList && customerContactChannelList.length > 0) {
          searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.UPDATE_ACTION
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
          searchField.itemName = 'quotationClient.CUSTOMER_CONTACT_CHANNEL'
          searchField.itemLabel = 'CargoMsg.Cargo_CustomerContactChannel'
          searchField.itemValue = []
          searchField.defaultSelected = 0
          searchField.selected = 0
          searchField.dropdownDataRef = ''
          searchField.lock = false
          searchField.defaultValue = []
          searchField.dataProvider = customerContactChannelList
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }

      return defaultSearchFields
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node && node.rowIndex === event.rowIndex && node.data) {
              const nodeJob = node.data
              if (nodeJob.uuid) this.selectedJob = nodeJob
            }
          })
        }
      })
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        const node = event.data
        if (node.uuid) this.selectedJob = node
      }
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
      })
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.uuid) this.selectedJob = node
    },
    // 更新左边栏位的条数
    updateCountData() {
      const conMap = {}
      conMap.officeId = this.$store.getters.currentOfficeId
      conMap.checkOwnerId = true
      conMap.modelType = this.modelType
      if (!this.$store.getters.isAdmin) {
        // 查询销售是我的客户
        if (this.modelType === 0 && !this.viewAllCustomer) {
          conMap.checkApprovedState = true
          conMap.userId = this.$store.getters.userId
        }

        // 查询销售组长本人及组员
        if (this.modelType === 1 && !this.viewAllCustomer) {
          conMap.checkApprovedState = true
          conMap.checkRoleGroupLeader = true
        }
      }
      const requestBody = { conMap }
      updateCountData(requestBody).then(res => {
        this.potentialCount = res.data.potentialCount || 0
        this.contemplationCount = res.data.contemplationCount || 0
        this.businessCount = res.data.businessCount || 0
        this.cooperationCount = res.data.cooperationCount || 0
        this.allCustomerCount = res.data.allCustomerCount || 0
      })
    },
    // 查询
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.name = keyword.trim() // 中文名、英文名
        this.filter.pageNum = 1
      }

      const roleMap = {}
      roleMap.name = this.filter.name
      roleMap.checkOwnerId = true// 我的客户、本组客户（不显示释放后的客户）

      this.conditions = []
      // 查询销售是我的客户【我的客户模块使用】
      if (!this.$store.getters.isAdmin && this.modelType === 0 && !this.viewAllCustomer) {
        roleMap.checkApprovedState = true // 我的客户、本组客户（显示审核通过或者无需审核的客户）
        this.conditions.push(new AdvancedSearchOption(null, 'quotationClient.OWNER_ID', this.$store.getters.userId).formatObj2Json())
      }
      // 查询销售组长本人及组员的客户【本组客户模块使用】
      if (!this.$store.getters.isAdmin && this.modelType === 1 && !this.viewAllCustomer) {
        roleMap.checkApprovedState = true // 我的客户、本组客户（显示审核通过或者无需审核的客户）
        roleMap.checkRoleGroupLeader = true // 查询销售组长本人及组员
      }
      // 客户状态
      if (this.customerStatusCode !== -1) {
        this.conditions.push(new AdvancedSearchOption(null, 'quotationClient.CUSTOMER_STATUS_CODE', this.customerStatusCode).formatObj2Json())
      }
      // 是否有效
      this.conditions.push(new AdvancedSearchOption(null, 'quotationClient.ACTIVE', 1).formatObj2Json())
      this.queryCommon(roleMap)
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (data) this.conditions = data
      // 高级查询条件组装
      const roleMap = {}
      this.handConditions(roleMap, this.conditions)
      this.queryCommon(roleMap)
    },
    // 查询公用
    queryCommon(roleMap) {
      roleMap.modelType = this.modelType
      const requestBody = {
        conditions: this.conditions,
        roleMap,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      this.$logger.log('requestBody====', requestBody)
      // 相当于老cargo 的 queryQuotationClientPageableFast2
      this.loading = getLoading()
      queryQuotationClientPageable(requestBody).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      // CARGO-20583系统组件自带的日期列检索可以去重复显示
      res.data.list.forEach(eve => {
        eve.dateCreated = ColumnUtils.dateLabelFunc(eve.dateCreated)
        eve.firstMeetDate = ColumnUtils.dateLabelFunc(eve.firstMeetDate)
      })
      this.rowData = res.data.list
      this.total = Number(res.data.total)
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize

      // 若查出来的数据左右不相等，则刷新左边栏位客户数
      if ((this.customerStatusCode === 0 && this.potentialCount !== this.total) ||
        (this.customerStatusCode === 1 && this.contemplationCount !== this.total) ||
        (this.customerStatusCode === 2 && this.businessCount !== this.total) ||
        (this.customerStatusCode === 3 && this.cooperationCount !== this.total) ||
        (this.customerStatusCode === -1)) {
        this.updateCountData()
      }
      this.selectedJobs = []
      if (this.gridApi) this.gridApi.clearFocusedCell()
    },
    // 处理高级查询条件
    handConditions(roleMap, conditions) {
      roleMap.checkOwnerId = true// 我的客户、本组客户（不显示释放后的客户）
      // 客户分配状态 ASSIGN_DATE为分配日期 ASSIGN_DATE!=null 说明客户已分配
      if (AdvancedSearchOption.hasField('quotationClient.ASSIGN_DATE', conditions)) {
        const ownerIdOption = AdvancedSearchOption.getOption('quotationClient.ASSIGN_DATE', conditions)
        AdvancedSearchOption.removeOption('quotationClient.ASSIGN_DATE', conditions)
        if (ownerIdOption.value > -1) {
          // 已分配,.大于1
          if (ownerIdOption.value === 1) {
            ownerIdOption.operator = AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code
          } else {
            ownerIdOption.operator = AdvancedSearchConsts.OPERATOR_IS_NULL.code
          }
          conditions.push(ownerIdOption.formatObj2Json())
        }
      }

      // 查询销售是我的客户【我的客户模块使用】
      if (!this.$store.getters.isAdmin && this.modelType === 0 && !this.viewAllCustomer) {
        roleMap.checkApprovedState = true // 我的客户、本组客户（显示审核通过或者无需审核的客户）
        conditions.push(new AdvancedSearchOption(null, 'quotationClient.OWNER_ID', this.$store.getters.userId).formatObj2Json())
      }
      // 查询销售组长本人及组员的客户【本组客户模块使用】
      if (!this.$store.getters.isAdmin && this.modelType === 1 && !this.viewAllCustomer) {
        roleMap.checkApprovedState = true // 我的客户、本组客户（显示审核通过或者无需审核的客户）
        roleMap.checkRoleGroupLeader = true // 查询销售组长本人及组员
      }

      // 客户状态
      if (AdvancedSearchOption.hasField('quotationClient.CUSTOMER_STATUS_CODE', conditions)) {
        const option = AdvancedSearchOption.getOption('quotationClient.CUSTOMER_STATUS_CODE', conditions)
        AdvancedSearchOption.removeOption('quotationClient.CUSTOMER_STATUS_CODE', conditions)
        if (this.customerStatusCode !== -1) {
          option.value = this.customerStatusCode
          conditions.push(option.formatObj2Json())
        }
      } else {
        if (this.customerStatusCode !== -1) {
          conditions.push(new AdvancedSearchOption(null, 'quotationClient.CUSTOMER_STATUS_CODE', this.customerStatusCode).formatObj2Json())
        }
      }
      // 是否有效
      if (!AdvancedSearchOption.hasField('quotationClient.ACTIVE', conditions)) {
        conditions.push(new AdvancedSearchOption(null, 'quotationClient.ACTIVE', 1).formatObj2Json())
      }
      // 即将到期天数
      if (AdvancedSearchOption.hasField('quotationClient.DUE_TIME', conditions)) {
        const option = AdvancedSearchOption.removeOption('quotationClient.DUE_TIME', conditions)
        roleMap.dueTime = { 'value': option.value, 'operator': option.operator }
      }
      // 所属城市
      if (AdvancedSearchOption.hasField('quotationClient.PROVINCE', conditions)) {
        const option = AdvancedSearchOption.removeOption('quotationClient.PROVINCE', conditions)
        const countryArr = []
        const provinceArr = []
        const cityArr = []
        const districtsArr = []
        for (const item of option.value) {
          switch (item.length) {
            case 1:
              countryArr.push(item[0])
              break
            case 2:
              provinceArr.push(item[1])
              break
            case 3:
              cityArr.push(item[2])
              break
            case 4:
              districtsArr.push(item[3])
              break
          }
        }
        if (countryArr.length > 0) {
          conditions.push({ ...option, fieldName: 'quotationClient.COUNTRY', value: countryArr })
        }
        if (provinceArr.length > 0) {
          conditions.push({ ...option, fieldName: 'quotationClient.PROVINCE', value: provinceArr })
        }
        if (cityArr.length > 0) {
          conditions.push({ ...option, fieldName: 'quotationClient.CITY', value: cityArr })
        }
        if (districtsArr.length > 0) {
          conditions.push({ ...option, fieldName: 'quotationClient.DISTRICTS', value: districtsArr })
        }
      }
    },
    // 查看
    toLook(row) {
      if (!row) {
        row = this.selectedJob || this.readSelectedRows()[0]
      }
      row.customerStatusCode = this.customerStatusCode
      this.$emit('look', row)
    },
    // 获取选中行
    readSelectedRows(tips = true) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 录入
    createHandler(row) {
      if (!row) row = {}
      row.customerStatusCode = this.customerStatusCode
      this.$emit('add', row)
    },
    // 签单
    signHandler() {
      const client = this.selectedJob
      if (!client) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseCheckClient'))
        return
      }
      if (!client.ownerId || client.ownerId <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SalesIsEmpty'))
        return
      }
      if (client.signed) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CurrentClientIsContracted'))
        return
      }
      this.signMatchTitleWindow.client = client
      this.signMatchTitleWindow.visible = true
    },
    // 签单成功重新查询
    signSuccessCallBackHandler() {
      this.toQuery()
    },
    // 释放
    releaseHandler() {
      const selectedItems = this.readSelectedRows(false)
      if (!selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseCheckClient'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_CTRLSPFCC'), this.$t('CargoMsg.Cargo_ConfirmNotification'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.loading = getLoading()
        const clientKeys = Array.from(selectedItems, p => p.uuid)
        const requestBody = {
          clientKeys: clientKeys,
          branchId: this.$store.getters.currentOfficeId
        }
        releaseQuotationClients(requestBody).then(res => {
          this.refreshAgGrid(true)
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => { })
    },
    // 刷新表格
    refreshAgGrid(runToQuery = false) {
      // 刷寻右边查询结果
      if (runToQuery) this.toQuery()
      this.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
    },
    // 导入模板下载
    btnInitTemplateClickHandler() {
      const fileName = 'ImportQuotationClientResult.xls'
      const folderName = 'sales'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    // 批量导入
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 导入成功
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    // excel 导入后逻辑处理
    onImportSucceeded(data) {
      // if (data) {
      //   if (data.indexOf(this.$t('Message.ImportSuccessful1')) !== -1) {
      //     this.$message.success(data)
      //   } else {
      //     this.$message.warning(data)
      //   }
      //   this.toQuery()
      // }
      if (data) {
        const resultDocumentId = data.resultDocumentId
        const successRow = data.successRow
        const errorRow = data.errorRow
        const errorStr = data.errorStr
        const storageURL = cache.config.get('StorageURL')
        console.log('storageURL -------------- ' + storageURL)
        const url = `${URL.common.findByFileId}/${resultDocumentId}?sessionId=${this.$store.getters.userInfo.sessionId}`
        let msg = ''
        if (errorStr !== '') {
          msg = errorStr
        } else {
          if (errorRow > 0) {
            msg = this.$t('Message.ImportSuccessful1') + successRow + this.$t('Message.ImportSuccessful2') + '，' + this.$t('Message.Failure') + errorRow + this.$t('Message.ImportSuccessful2') + '，' + this.$t('SeaExport.ReImportAfterModification') + '<br><a href="' + url + `" target="_blank" style="color:#46a6ff" >${this.$t('Message.DownloadFailedData')}</a>`
          } else {
            msg = this.$t('Message.ImportSuccessful1') + successRow + this.$t('Message.ImportSuccessful2') + '，' + this.$t('Message.Failure') + errorRow + this.$t('Message.ImportSuccessful2')
          }
        }
        this.$confirm(msg, this.$t('common.tips.systemPrompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {}).catch(() => {})
        // this.toQuery()
      }
    },
    // 左边客户状态点击切换
    categoryClick(customerStatusCode) {
      this.customerStatusCode = customerStatusCode
      this.toAdvancedQuery()
    },
    // 分配
    assignHandler() {
      const selectedItems = this.readSelectedRows(false)
      if (!selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CustomerNotSelected'))
        return
      }
      this.customerAssignWindow.sales = ''
      this.customerAssignWindow.selectedItems = selectedItems
      this.customerAssignWindow.visible = true
    },
    // 确认分配
    enterAssignHandler() {
      if (!this.customerAssignWindow.sales || parseInt(this.customerAssignWindow.sales) === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SalesNotSelected'))
        return
      }
      this.loading = getLoading()
      const clientKeys = Array.from(this.customerAssignWindow.selectedItems, p => p.uuid)
      const conMap = {
        ownerId: this.customerAssignWindow.sales,
        sourceType: CrmCustomerConstants.SOURCE_TYPE_LEADER_ASSIGN.code
      }
      const requestBody = {
        conMap,
        clientKeys: clientKeys,
        branchId: this.$store.getters.currentOfficeId
      }
      assignQuotationClients(requestBody).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_AssignedClientsSuccessfully', [this.customerAssignWindow.selectedItems.length]))
        this.refreshAgGrid(true)
      }).finally(() => {
        this.customerAssignWindow.visible = false
        this.loading.close()
      })
    },
    // 延长期限
    additionalHandler() {
      const selectedItems = this.readSelectedRows(false)
      if (!selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckClientToExtendValidPeriod'))
        return
      }
      if (selectedItems.length > 1) {
        this.$message.warning(this.$t('Message.TheCaseOfMultipleFirst'))
        return
      }
      this.customerAdditionalWindow.client = selectedItems[0]
      this.customerAdditionalWindow.selectedItems = selectedItems
      this.customerAdditionalWindow.isPartner = parseInt(this.customerAdditionalWindow.client.customerStatusCode) === parseInt(CrmCustomerConstants.STAGE_COOPERATION.code)
      if (this.customerAdditionalWindow.isPartner) {
        this.customerAdditionalWindow.days = this.customerAdditionalWindow.client.sleepDays
      } else {
        this.customerAdditionalWindow.days = this.customerAdditionalWindow.client.signedDays
      }
      this.customerAdditionalWindow.visible = true
    },
    // 确认延长
    enterAdditionalHandler() {
      if (this.customerAdditionalWindow.days <= 0) {
        this.$message.warning(this.$t('Message.InvalidNumberEntered'))
        return
      }
      const conMap = {}
      if (this.customerAdditionalWindow.isPartner) {
        conMap.sleepDays = this.customerAdditionalWindow.client.sleepDays = this.customerAdditionalWindow.days || 0
      } else {
        conMap.signedDays = this.customerAdditionalWindow.client.signedDays = this.customerAdditionalWindow.days || 0
      }
      this.loading = getLoading()
      const clientKeys = Array.from(this.customerAdditionalWindow.selectedItems, p => p.uuid)
      const requestBody = {
        conMap,
        clientKeys: clientKeys,
        branchId: this.$store.getters.currentOfficeId
      }
      updateQuotationClientField(requestBody).then(res => {
        this.refreshAgGrid(false)
      }).finally(() => {
        this.customerAdditionalWindow.visible = false
        this.loading.close()
      })
    },
    // 导出excel
    exportExcelEvent() {
      const header = this.columnDefs.map(p => p.headerName)
      header.splice(0, 1)
      // 获取选中行
      const rows = this.readSelectedRows(false)
      if (rows && rows.length > 0) {
        const data = rows.map(row => {
          const arr = []
          for (const column of this.columnDefs) {
            if (!column.headerName) continue
            if (column.field === 'customerStatusCode') {
              const label = ColumnUtils.customerStatusCodeToColumnLabelFun(row[column.field])
              arr.push(label)
              continue
            }
            const label = typeof column.cellRenderer === 'function'
              ? column.cellRenderer({ data: row, value: row[column.field] })
              : row[column.field]
            arr.push(label)
          }
          return arr
        })
        import('@/vendor/Export2Excel').then(excel => {
          excel.export_json_to_excel({
            header,
            data,
            filename: `${this.$t('CargoMsg.Cargo_CustomersInThisGroup')}_${moment().format('YYYYMMDDkkmmss')}`
          })
        }).finally(() => {
          this.$message.success(this.$t('CargoMsg.Cargo_ExportClientSuccessfully'))
        })
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectTheCustomerToExport'))
      }
    },
    // 删除
    deleteHandler() {
      if (!this.selectedJob) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectForDelete'))
        return
      }
      this.loading = getLoading()
      const requestBody = {
        conMap: { clientKey: this.selectedJob.uuid },
        branchId: this.$store.getters.currentOfficeId
      }
      checkDeleteCustomer(requestBody).then(res => {
        const canBeDeleteStatus = res.data.canBeDeleteStatus
        if (canBeDeleteStatus === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteFailed'))
          return
        }
        if (canBeDeleteStatus === 2) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CannotBeDeleted'))
          return
        }
        if (canBeDeleteStatus === 1) {
          this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureDelete'), this.$t('common.tips.confirm'), {
            confirmButtonText: this.$t('common.btn.yes'),
            cancelButtonText: this.$t('common.btn.no'),
            closeOnClickModal: false,
            type: 'info'
          }).then(() => {
            this.loading = getLoading()
            deleteCustomer(requestBody).then(res => {
              const result = res.data
              if (result === 1) {
                this.$message.success(this.$t('CargoMsg.Cargo_DeleteSuccessfully'))
                this.refreshAgGrid(true)
              }
            }).finally(() => {
              this.loading.close()
            })
          }).catch(() => { })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    newEventRecordHandler() {
      const rows = this.selectedJobs
      if (!rows || rows.length === 0) return
      // 我的客户
      this.eventRecordDialog.editSupervisorComments = this.$checkPermission(['role_TabCRMCustomerEvent_supervisorComments'])
      this.eventRecordDialog.isEditTime = true
      this.eventRecordDialog.form = { ...this.eventRecordDialog.initialForm }
      this.eventRecordDialog.form.recorderId = this.$store.getters.userId
      this.eventRecordDialog.form.recordTime = new Date()
      this.eventRecordDialog.form.taskTime = new Date()
      this.eventRecordDialog.form.quotationClientUuid = rows[0].uuid
      const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(this.eventRecordDialog.form.recorderId))
      this.eventRecordDialog.form.recorderName = this.$store.getters.language === 'zh' ? user.chineseName : user.englishName
      this.eventRecordDialog.visible = true
    },
    // 取消
    recordDialogClose() {
      this.eventRecordDialog.visible = false
    },
    // 保存
    async recordDialogSave() {
      if (!this.eventRecordDialog.form.titleName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectSubject'))
        return
      }
      if (!this.eventRecordDialog.form.status) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectEventStatus'))
        return
      }
      const quotationClientEvent = lodash.cloneDeep(this.eventRecordDialog.form)
      if (!quotationClientEvent.quotationClientUuid) quotationClientEvent.quotationClientUuid = this.selectedJobs[0].uuid
      this.loading = getLoading()
      await saveQuotationClientEvent(quotationClientEvent).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      }).finally(() => {
        this.loading.close()
        this.recordDialogClose()
      })
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      return currDate < new Date()
    }
  }
}
</script>

<style lang="scss">
#myCustomer-tree-grid {
  .custom-category-list{
    margin-top: 0;
    margin-right: 5px;
    list-style: none;
    min-width: 150px;
    li {
      position: relative;
      padding:10px 25px;
      border:1px solid #d9d9d9;
      border-bottom: none;
      cursor: pointer;
      &:nth-last-child(1){
        border:1px solid #d9d9d9;
      }
      &.active {
        background-color: #009fd6;
        color:#fff;
        &::before{
          content:'';
          position: absolute;
          width: 5px;
          top:0;
          left:0;
          bottom:0;
          background-color: rgba(0,0,0,.3);
        }
        border-color: #009fd6;
        &.potential{
          background-color: #8DCE64;
          border-color: #8DCE64;
        }
        &.contemplation{
          background-color: #00A795;
          border-color: #00A795;
        }
        &.business{
          background-color: #00A6F4;
          border-color: #00A6F4;
        }
        &.cooperation{
          background-color: #5469BA;
          border-color: #5469BA;
        }
      }
    }
  }
}
</style>
